import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrDashboardApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    dashboardSummary(owningCompanyId?: number, companyGroupId?: number, memberCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrPhase0Summary>> {
        return this.http.get<APIResponseWrapper<HrModels.HrPhase0Summary>>(`${this.baseUrl}/dashboard/summary`, {
          params: this.params({ owningCompanyId, companyGroupId, memberCompanyId })
        });
      }
  };
}

